module.exports = __webpack_public_path__ + "img/WeKnowTheDevil.edb5d87e.jpg";